import { render } from "./DashboardAdminSales.vue?vue&type=template&id=4518938b&scoped=true"
import script from "./DashboardAdminSales.vue?vue&type=script&lang=js"
export * from "./DashboardAdminSales.vue?vue&type=script&lang=js"

import "./DashboardAdminSales.vue?vue&type=style&index=0&id=4518938b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4518938b"]])

export default __exports__